"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorBoundary = void 0;
var _react = require("react");
var _InternalErrorBoundary = require("./internal/InternalErrorBoundary");
var _loggerContext = require("./loggerContext");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * ErrorBoundary component that wraps around the provided children and handles any errors that occur within it.
 * It uses a logger to log the errors to Application Insights and provides a fallback UI in case of an error.
 * It will try to detect the logger from the context if no logger is provided in the parameters.
 *
 * @param {ReactNode} fallback The fallback to be displayed in case of an error - can be a component, or a function returning a component.
 * @param {string} areaName The name of the area for which the logger is created.
 * @param {ChildLogger} logger The logger instance to be used for logging errors.
 * @returns {JSX.Element} The rendered ErrorBoundary component.
 * @throws If no logger was provided in the parameters or detected in the context.
 */

const ErrorBoundary = ({
  children,
  fallback,
  ...rest
}) => {
  const areaName = 'areaName' in rest ? rest.areaName : undefined;
  const paramLogger = 'logger' in rest ? rest.logger : undefined;
  const parentLogger = (0, _react.useContext)(_loggerContext.loggerContext);
  const logger = (0, _react.useMemo)(() => {
    if (paramLogger) {
      return paramLogger;
    }
    if (areaName && parentLogger) {
      return parentLogger.createChild(areaName);
    }
    throw new Error('No logger was provided in the parameters or detected in the context');
  }, [paramLogger, areaName, parentLogger]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InternalErrorBoundary.InternalErrorBoundary, {
    logger: logger,
    fallback: fallback,
    children: children
  });
};
exports.ErrorBoundary = ErrorBoundary;
//# sourceMappingURL=ErrorBoundary.js.map